import React, { useState, useContext } from 'react'
import { themeContext } from '../../Context'
import './About.css'
import { Container, Row, Col } from 'reactstrap'
import profile from '../../assets/profilepic.png'
import Education from './Education'
import Skills from './Skills'
import Awards from './Awards'
import calculateExp from '../../experienceCalculator'

const About = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode;
    const [aboutFilter, setAboutFilter] = useState('ABOUT');
    return <section id="about" className='mb-5'>
        <Container>
            <Row>
                <Col lg='12' className='mb-5'>
                    <h2> About Me </h2> {''}
                </Col>
                <Col lg='4' md='3'>
                    <div className='about_btns d-flex flex-column align-items-center' style={{ background: darkMode ? '#102048' : 'rgb(216 212 232)' }}>
                        <button className={`about_btn ${aboutFilter === 'ABOUT' ? (darkMode ? 'about_btn-active about_btn_color_dark' : 'about_btn-active-light about_btn_color_light') : ''}`} onClick={() => setAboutFilter('ABOUT')}> About me </button>
                        <button className={`about_btn ${aboutFilter === 'EDUCATION' ? (darkMode ? 'about_btn-active about_btn_color_dark' : 'about_btn-active-light about_btn_color_light') : ''}`} onClick={() => setAboutFilter('EDUCATION')}> Education </button>
                        <button className={`about_btn ${aboutFilter === 'SKILLS' ? (darkMode ? 'about_btn-active about_btn_color_dark' : 'about_btn-active-light about_btn_color_light') : ''}`} onClick={() => setAboutFilter('SKILLS')}> Skills </button>
                        <button className={`about_btn ${aboutFilter === 'AWARDS' ? (darkMode ? 'about_btn-active about_btn_color_dark' : 'about_btn-active-light about_btn_color_light') : ''}`} onClick={() => setAboutFilter('AWARDS')}> Awards </button>
                    </div>
                </Col>
                <Col lg='8' md='9'>
                    {
                        aboutFilter === 'ABOUT' && <>
                            <div className="about_content_wrapper d-flex gap-5" style={{ background: darkMode ? '#132347' : 'rgb(216 212 232)' }}>
                                <div className="about_img w-25">
                                    <img src={profile} alt="" className="w-100"></img>
                                </div>
                                <div className="about_content w-75">
                                    <h2> I'm ShashiKanth Mogilicherla </h2>
                                    <p> Rising Star Award winning web developer with {calculateExp(new Date('7/23/2019'))}+ years of experience in React, OJET, HTML, CSS, Knockout JS and JavaScript. Experienced in responsive web-development and enhancement, client relationship management. Successfully trained group of fresher developers to meet project technical requirements. Good Knowledge on React JS, JAVA, Data Structures and Algorithms.</p>
                                    <div className='d-flex'>
                                        <div className='w-50'>
                                            <p>Date Of Birth</p>
                                            <p>Address</p>
                                            <p>Zip code</p>
                                            <p>Email</p>

                                        </div>
                                        <div className='w-50'>
                                            <p>:    03 April 1998</p>
                                            <p>:    Warangal, Telangana, India</p>
                                            <p>:    506002</p>
                                            <p>:    mogilicherlashashi@gmail.com</p>
                                            
                                        </div>
                                    </div>
                                    <div className="social_links">
                                        <h6 className='mb-3'> Connect with me : </h6>
                                        <span> <a href="#"> <i className=" ri-facebook-line "> </i> </a> </span>
                                        <span> <a href="#"> <i className=" ri-youtube-line "> </i> </a> </span>
                                        <span> <a href="#"> <i className=" ri-github-line "> </i> </a> </span>
                                        <span> <a href="#"> <i className=" ri-instagram-line "> </i> </a> </span>
                                        <span> <a href="#"> <i className=" ri-linkedin-line "> </i> </a> </span>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {
                        aboutFilter === 'EDUCATION' && <Education />
                    }
                    {
                        aboutFilter === 'SKILLS' && <Skills />
                    }
                    {
                        aboutFilter === 'AWARDS' && <Awards />
                    }

                </Col>
            </Row>
        </Container>
    </section>
}
export default About